import { configureStore } from "@reduxjs/toolkit";
import modal from "../features/Modal/slice";
import navigationDrawer from "../features/NavigationDrawer/slice";
import theme from "../features/Theme/slice";

const store = configureStore({
  reducer: { modal, theme, navigationDrawer },
});

// eslint-disable-next-line no-undef
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
